import getConfig from 'next/config';

const {publicRuntimeConfig } = getConfig()
type RuntimeConfig = {
  BASE_API_URL: any;
  BASE_BUILD_API_URL: any;
  ASSETPREFIX_PATH: any;
  DEBUG: any;
  DEFAULT_HEADER: {
    Accept: string;
    'Content-Type': string;
  };
  HUMAN_READABLE_DATE_FORMAT: string;
  gtmCode: any;
  BASE_URL: any;
  instaPayLater: any;
  homecarePremuim: any;
  CLEVER_TAP_ACCOUNT_ID: any;
  CRITEO_SALT: any;
  GOOGLE_MAP_KEY: any;
  CLARITY_ACCOUNT_ID: any;
  RECAPTCHA_V3_SITE_KEY: any;
  RECAPTCHA_V2_SITE_KEY: any;
}
const Config: RuntimeConfig = {
  BASE_API_URL:publicRuntimeConfig.baseAPIPath,
  BASE_BUILD_API_URL:publicRuntimeConfig.baseBuildPath,
  ASSETPREFIX_PATH: publicRuntimeConfig.ASSETPREFIX,
  DEBUG: publicRuntimeConfig.DEBUG,
  DEFAULT_HEADER: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  HUMAN_READABLE_DATE_FORMAT: "DD MMM, YYYY",
  gtmCode: publicRuntimeConfig.gtmCode,
  BASE_URL:publicRuntimeConfig.BASE_URL,
  instaPayLater:publicRuntimeConfig.instaPayLater,
  homecarePremuim:publicRuntimeConfig.homecarePremuim,
  CLEVER_TAP_ACCOUNT_ID: publicRuntimeConfig.CLEVER_TAP_ACCOUNT_ID,
  CRITEO_SALT: publicRuntimeConfig.CRITEO_SALT,
  GOOGLE_MAP_KEY: publicRuntimeConfig.GOOGLE_MAP_KEY,
  CLARITY_ACCOUNT_ID: publicRuntimeConfig.CLARITY_ACCOUNT_ID,
  // Read from process.env (inlined at build time via next.config.js `env`)
  // instead of publicRuntimeConfig, which is empty on statically-optimized
  // pages (no getServerSideProps/getInitialProps) and was the root cause of
  // the "Missing required parameters: sitekey" crash on /selfserve/tracker/*.
  RECAPTCHA_V3_SITE_KEY: process.env.RECAPTCHA_V3_SITE_KEY || "",
  RECAPTCHA_V2_SITE_KEY: process.env.RECAPTCHA_V2_SITE_KEY || "",
}

export default Config;
